import { Link } from "react-router-dom";

import useLocalStorage from "../../../hooks/storage/localstorage";
import { ClickStatData } from "../StoreClickStats/interface";
import { StoreClickStatsKey } from "../StoreClickStats/StoreClickStats";

const ClickStats = (): JSX.Element => {
  const [localValue] = useLocalStorage<ClickStatData[]>(StoreClickStatsKey);

  const clicks = localValue?.reduce((acc, curr) => acc + curr.clicks, 0) ?? 0;

  return <Link to="/click-stats">{clicks} clicks</Link>;
};

export default ClickStats;
